import type {Variants} from "../types";
import {fontFamily} from "./fontFamily";
import {fontWeight} from "./fontWeight";

const pxToRem = (size: number) => `${(size / 16) * 1}rem`;

export const variants: Variants = {
    display1: {
        fontFamily: fontFamily.secondary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(48),
        lineHeight: 1.08333,
        letterSpacing: 0,
        textTransform: "uppercase",
    },
    display2: {
        fontFamily: fontFamily.secondary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(32),
        lineHeight: 1.1875,
        letterSpacing: 0,
        textTransform: "uppercase",
    },
    display3: {
        fontFamily: fontFamily.secondary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(24),
        lineHeight: 1.16667,
        letterSpacing: 0,
        textTransform: "uppercase",
    },
    display4: {
        fontFamily: fontFamily.secondary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(20),
        lineHeight: 1.3,
        letterSpacing: 0,
        textTransform: "uppercase",
    },
    display5: {
        fontFamily: fontFamily.secondary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(16),
        lineHeight: 1.375,
        letterSpacing: 0,
        textTransform: "uppercase",
    },
    title1: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.bold,
        fontSize: pxToRem(28),
        lineHeight: 1.35714,
        letterSpacing: 0,
    },
    title2: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.bold,
        fontSize: pxToRem(24),
        lineHeight: 1.33333,
        letterSpacing: -0.01,
    },
    title3: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.bold,
        fontSize: pxToRem(20),
        lineHeight: 1.3,
        letterSpacing: 0,
    },
    title4: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.bold,
        fontSize: pxToRem(16),
        lineHeight: 1.375,
        letterSpacing: 0.1,
    },
    title5: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.bold,
        fontSize: pxToRem(14),
        lineHeight: 1.42857,
        letterSpacing: 0.1,
    },
    title6: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.bold,
        fontSize: pxToRem(12),
        lineHeight: 1.33333,
        letterSpacing: 0.1,
    },
    body1: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(20),
        lineHeight: 1.4,
        letterSpacing: 0,
    },
    body2: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(16),
        lineHeight: 1.5,
        letterSpacing: 0,
    },
    body3: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(14),
        lineHeight: 1.57143,
        letterSpacing: 0,
    },
    body4: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(12),
        lineHeight: 1.5,
        letterSpacing: 0,
    },
    label1: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.bold,
        fontSize: pxToRem(12),
        lineHeight: 1.33333,
        letterSpacing: 0.4,
        textTransform: "uppercase",
    },
    label2: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.bold,
        fontSize: pxToRem(10),
        lineHeight: 1.4,
        letterSpacing: 0.4,
        textTransform: "uppercase",
    },
    label3: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.bold,
        fontSize: pxToRem(9),
        lineHeight: 1.33333,
        letterSpacing: 0.4,
        textTransform: "uppercase",
    },
    editorialPreamble: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.medium,
        fontSize: 20,
        lineHeight: 1.4,
        letterSpacing: 0,
    },
    editorialBody: {
        fontFamily: fontFamily.primary,
        fontWeight: fontWeight.regular,
        fontSize: pxToRem(16),
        lineHeight: 1.625,
        letterSpacing: 0,
    },
};
